import React, { useState, useEffect } from 'react'
import Presentation from "./Presentation"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import { notifyDefaulter } from "../../../middleware/index"

function Container(props) {
  const { employeeID, isRejected, isDefaulter, email, name, timesheetManager, id } = props.row
  const { loggedInEmployee, _notify_defaulter, reduxState } = props
  const [state, stateSetter] = useState({
    open: false,
    description: "",
    hideBtn: true,
    email: email,
    subject: "Defaulter Timesheet",
    body: `Hey ${name}, you need to submit your pending timesheet.`,
    name: name
  })

  const setState = (obj) => {
    stateSetter(prevState => ({
      ...prevState,
      ...obj
    }))
  }

  useEffect(() => {
    // button hide conditions
    /* 
      1) His own timesheet
      2) if rejected
      3) if defaulter
    */
    if (timesheetManager.includes(loggedInEmployee) && isDefaulter) {
      setState({ hideBtn: false })
    }
  }, [isDefaulter])


  const handleClickOpen = () => {
    setState({ open: true })
  };
  const handleClose = () => {
    setState({ open: false })
  };

  const onNotify = () => {
    handleClose()
    const inputs = {
      to: state.email,
      subject: state.subject,
      body: state.body
    }
    _notify_defaulter(inputs, employeeID, id)
  }

  return (
    <div>
      <Presentation
        state={state}
        setState={setState}
        handleClickOpen={handleClickOpen}
        handleClose={handleClose}
        setState={setState}
        onNotify={onNotify}
        reduxState={reduxState}
        employeeID={employeeID}
        timesheetID={id}
      />
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    loggedInEmployee: state.firebase.auth.uid,
    reduxState: state.timesheets.info
  }
}

const mapDispatchToProps = dispatch => ({
  _notify_defaulter: (inputs, employeeID, timesheetID) => dispatch(notifyDefaulter(inputs, employeeID, timesheetID))
})


export default connect(mapStateToProps, mapDispatchToProps)(Container)